// extracted by mini-css-extract-plugin
export var aboutContainer = "index-module--aboutContainer--8e3f5";
export var container = "index-module--container--f8c32";
export var headshot = "index-module--headshot--7f93b";
export var headshotContainer = "index-module--headshotContainer--b7a28";
export var links = "index-module--links--cb3eb";
export var subtitle = "index-module--subtitle--4373f";
export var title = "index-module--title--16c47";